/* globals TimelineMax, TweenMax */
define('navigation-transition',['helpers'], function(helpers) {

    var root = document.documentElement,
        isLoading = false,
        hiddenCSS = 'is-completed',
        loadingCSS = 'is-loading',
        postfix = '';

    function getLastTimeline(props) {
        var max = 0,
            total = 0,
            timeline = '',
            getTotal = function(duration, from, to) {
                return (((duration) ? parseFloat(duration) : 0) + ((from) ? parseFloat(from) : 0) + ((to) ? parseFloat(to) : 0)) * 1000;
            };

        props.forEach(function(prop) {
            total = getTotal(prop.duration, prop.paramsFrom.delay, prop.paramsTo.delay);

            if (total > max) {
                max = total;
                timeline = prop.element;
            }
        });

        return timeline;
    }

    function Transition(options) {
        options = options || {};

        this.duration = options.duration || 150;

        this.transition = (options.transition) ? options.transition.toLowerCase() : 'css';

        this.params = options.transitionparams || {};
    }

    Transition.prototype.initLoading = function(swiping, dir, updateVM) {
        var _this = this;

        dir = (dir) ? dir.toLowerCase() : '';

        postfix = ((dir === 'back') ? 'Back' : 'Forward') + ((swiping) ? 'Swipe' : '');

        if (isLoading) {
            return;
        }

        isLoading = true;

        switch(_this.transition) {
        case 'none':

            updateVM();
            helpers.layout.scrollTop();

            break;
        case 'css':

            root.classList.add(loadingCSS);

            setTimeout(function() {

                updateVM();
                helpers.layout.scrollTop();

            }, _this.duration/2);

            break;
        case 'tweenmax':

            require(['gsap'], function() {
                var prop = 'transitionOut' + postfix,
                    last = '',
                    timelines = {};

                if (!_this.params[prop]) {
                    updateVM();
                    helpers.layout.scrollTop();
                    return;
                }

                last = getLastTimeline(_this.params[prop]);

                _this.params[prop].forEach(function(data) {
                    if (!timelines[data.element]) {
                        timelines[data.element] = (last === data.element) ? new TimelineMax({onComplete: function() {
                            root.classList.add(hiddenCSS);
                            updateVM();
                            helpers.layout.scrollTop();
                        }}) : new TimelineMax();
                    }

                    timelines[data.element].add(TweenMax.fromTo(data.element, data.duration, data.paramsFrom, data.paramsTo));
                });

            });

            break;
        }
    };

    Transition.prototype.completeLoading = function() {
        var _this = this;

        if (!isLoading) {
            return;
        }

        switch(_this.transition) {
        case 'css':

            root.classList.remove(loadingCSS);

            setTimeout(function() {
                isLoading = false;
            }, _this.duration);

            break;
        case 'tweenmax':

            require(['gsap'], function() {
                var prop = 'transitionIn' + postfix,
                    last = '',
                    timelines = {};

                if (!_this.params[prop]) {
                    isLoading = false;
                    return;
                }

                last = getLastTimeline(_this.params[prop]);

                _this.params[prop].forEach(function(data) {
                    if (!timelines[data.element]) {
                        timelines[data.element] = (last === data.element) ? new TimelineMax({
                            onStart: function() {
                                root.classList.remove(hiddenCSS);
                            },
                            onComplete: function() {
                                isLoading = false;
                            }
                        }) : new TimelineMax();
                    }

                    timelines[data.element].add(TweenMax.fromTo(data.element, data.duration, data.paramsFrom, data.paramsTo));
                });
            });

            break;
        default:
            isLoading = false;
        }
    };

    return Transition;

});

